module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-500-medium-italic-7250540daa71415eb704ddbf140fb133.woff2";